import { createRouter, createWebHistory } from 'vue-router';
import store from '../store/index';
import { setPageMeta } from '@/utils/seo';

const routes = [
  {
    path: '/',
    component: () => import('@/components/Layout.vue'),
    children:[
      {
        path:'/',
        component: () => import('@/components/Home.vue'),
        name:'Home',
        meta: {
          title: 'LimmekRent - Professzionális szerszám- és gépkölcsönzés',
          description: 'Professzionális szerszámok és gépek bérlése rövid és hosszú távra. Széles eszközválaszték, rugalmas bérleti feltételek, szakértő ügyfélszolgálat.'
        }
      },
      {
        path:'/shop',
        component: () => import('@/views/Shop'),
        name:'Shop',
        meta: {
          title: 'Eszközök bérlése és vásárlása - LimmekRent',
          description: 'Böngéssz professzionális szerszámok és gépek széles választékában. Napi, heti vagy havi bérlés, azonnali vásárlási lehetőség.'
        }
      },
      {
        path:'/accountmanagement',
        component: () => import('@/views/AccountManagementView.vue'),
        name:'AccountManagement',
        meta: { requiresAuth: true }
      },
      {
        path:'/checkout',
        component: () => import('@/views/CheckoutView.vue'),
        name:'CheckoutView',
        meta: { title: 'Megrendelés véglegesítése - LimmekRent' }
      },
      {
        path:'/summary',
        component: () => import('@/views/SummaryView.vue'),
        name:'SummaryView',
        meta: { title: 'Rendelés összesítés - LimmekRent' }
      },
      {
        path:'/admin',
        component: () => import('@/views/AdminView.vue'),
        name:'Admin'
      },
      {
        path:'/controlpanel',
        component: () => import('@/views/ControlPanelView.vue'),
        name:'ControlPanel',
        meta: { requiresAuth: true, role: 'admin' }
      },
      {
        path:'/useractivation',
        component: () => import('@/components/UserActivation.vue'),
        name:'UserActivation'
      },
      {
        path:'/unsubscribenewsletter',
        component: () => import('@/components/UnsubscribeNewsletter.vue'),
        name:'UnsubscribeNewsletter'
      },
      {
        path:'/passwordreset',
        component: () => import('@/components/PasswordReset.vue'),
        name:'PasswordReset'
      },
      {
        path:'/impresszum',
        component: () => import('@/views/ImpresszumView.vue'),
        name:'Impresszum',
        meta: {
          title: 'Impresszum - LimmekRent',
          description: 'A LimmekRent (Limmek Work Kft.) jogi és céges adatai, elérhetőségei.'
        }
      }
    ]
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return { top: 0 };
  }
});

// Set document title/meta description/canonical from route.meta. Dynamic
// routes (e.g. a specific product) override this from within the component
// once the actual product data is resolved.
router.afterEach((to) => {
  setPageMeta({
    title: to.meta.title,
    description: to.meta.description,
    path: to.fullPath
  });
});

// Navigation guard to check if user is authenticated before navigating to protected routes
router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth) {
    if (to.meta.role === 'admin') {
      // Check for admin authentication
      const isAdminAuthenticated = !!store.state.adminAccessToken;
      if (isAdminAuthenticated) {
        next(); // Proceed to the route
      } else {
        next({ name: 'Admin' }); // Redirect to admin login if not authenticated
      }
    } else {
      // Check for regular user authentication
      const isAuthenticated = !!store.state.userAccessToken;
      if (isAuthenticated) {
        next(); // Proceed to the route
      } else {
        next({ name: 'Home', path:'/' }); // Redirect to Home if not authenticated
      }
    }
  } else {
    next(); // Continue navigation for routes that do not require authentication
  }
});

export default router;
